{
  "version": 1,
  "asset_id": "ef3168b2-047a-473f-ab80-2eb110090c2d",
  "project_id": "41a2ff96-d576-402d-a149-9ffc32b4814a",
  "url": "/__l5e/assets-v1/ef3168b2-047a-473f-ab80-2eb110090c2d/chris-helvajian.jpg",
  "r2_key": "a/v1/41a2ff96-d576-402d-a149-9ffc32b4814a/ef3168b2-047a-473f-ab80-2eb110090c2d/chris-helvajian.jpg",
  "original_filename": "chris-helvajian.jpg",
  "size": 1451629,
  "content_type": "image/png",
  "created_at": "2026-07-28T14:55:18Z"
}
